import { render } from "./ZhaiHeadPC.vue?vue&type=template&id=9f1fbcd6&scoped=true"
import script from "./ZhaiHeadPC.vue?vue&type=script&lang=js"
export * from "./ZhaiHeadPC.vue?vue&type=script&lang=js"

import "./ZhaiHeadPC.vue?vue&type=style&index=0&id=9f1fbcd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1fbcd6"]])

export default __exports__